import { alertQueue, AlertType, Button, Flex } from "@connectme2/ui";
import { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router";
import { Services } from "../components/ServiceInterface";
import { DstnyForDevelopersIcon } from "../components/icons";
import { Loader } from "../components/lib/Loader/Loader";
import GlobalService from "../services/Service";

const globalService = new GlobalService();

function WelcomePage() {

    const initialized = useRef(false);
    const [services, setServices] = useState<Services | undefined>(undefined);

    const load = useCallback(async () => {
        if (initialized.current) {
            return;
        }
        initialized.current = true;
        const onboarded = localStorage.getItem("onboarded") === "true"
        try {
            const services = await globalService.services()
            localStorage.setItem("services", JSON.stringify(services));
            setServices(services)
            if (onboarded) {
                window.location.href = services.console_url
                return
            }
        } catch (error: any) {
            console.error(error);
            alertQueue.add({
                type: AlertType.error,
                title: "Error to get services",
                description: error,
                hasClose: true
            })
        }
    }, []); // put dependencies here if load u

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        (async () => {
            await load();
        })();
    }, [load]);

    if (services === undefined) {
        return <div className="app-welcome">
            <Loader />
        </div>
    }

    return <div className="app-box app-welcome">
        <Flex direction="column" alignItems="center">
            <DstnyForDevelopersIcon />
            <h1>Welcome Developer</h1>
            <p className="description">We’re excited to have you here! This onboarding will guide you through the
                tools, APIs, and resources
                you need to start building quickly. Our goal is to make your developer experience seamless so you can
                focus on what matters most: creating amazing products.
            </p>
            <Flex direction="row" alignItems="center" gap="xl">
                <NavLink to="/register">
                    <Button>I am new</Button>
                </NavLink>
                <a href={services.console_url}><Button variant="outline">Sign-in</Button></a>
            </Flex>
        </Flex>
    </div>
}


export default WelcomePage;
